import { SearchStyleModel } from '@/models/header/v2/SearchModel'

export function formatSearchStyle(data) {
  const h = new SearchStyleModel()
  h.fromData(data)

  return h
}
